/* PADELIT — wireframe interactions */
(() => {
  const $  = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => [...ctx.querySelectorAll(s)];

  /* ---------- Mega Menu (desktop, click + hover) ----------
     The panel hangs off .header (top:100% of the sticky header) while .nav__item is
     only as tall as its link, so there is a band between them that belongs to
     neither. Moving down slowly crosses it, fires mouseleave, and the menu vanishes
     just as you reach for it. A short grace period on close covers that gap — the
     timer is cancelled the moment the pointer comes back to the item or the panel. */
  const MEGA_CLOSE_GRACE = 220; // ms
  $$('.nav__item').forEach(item => {
    const link = item.querySelector('.nav__link');
    const mega = item.querySelector('.mega');
    if (!link || !mega) return;
    let closeTimer = null;
    const cancelClose = () => { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } };
    const open  = () => { cancelClose(); closeAllMegas(item); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); };
    const close = () => { cancelClose(); item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); };
    const closeSoon = () => { cancelClose(); closeTimer = setTimeout(close, MEGA_CLOSE_GRACE); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', closeSoon);
    // The panel is a descendant so this is belt-and-braces, but it also covers a
    // pointer that re-enters the panel during the grace period.
    mega.addEventListener('mouseenter', cancelClose);
    mega.addEventListener('mouseleave', closeSoon);
    link.addEventListener('click', e => {
      e.preventDefault();
      item.classList.contains('is-open') ? close() : open();
    });
  });
  function closeAllMegas(except) {
    $$('.nav__item.is-open').forEach(el => {
      if (el !== except) { el.classList.remove('is-open'); el.querySelector('.nav__link')?.setAttribute('aria-expanded', 'false'); }
    });
  }
  document.addEventListener('click', e => {
    if (!e.target.closest('.nav__item')) closeAllMegas();
  });

  /* ---------- Drawers (generic open/close) ---------- */
  const scrim = $('#scrim');
  function openDrawer(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    scrim?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (id === 'searchDrawer') { const i = el.querySelector('#searchInput'); if (i) setTimeout(() => i.focus(), 60); }
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(d => d.classList.remove('is-open'));
    scrim?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  // Delegated so buttons re-created by AJAX (e.g. the cart drawer after add) still work
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    if (e.target.closest('[data-close-drawer]')) closeDrawers();
  });
  scrim?.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Qty steppers ---------- */
  document.addEventListener('click', e => {
    const inc = e.target.closest('[data-qty="+"]');
    const dec = e.target.closest('[data-qty="-"]');
    if (!inc && !dec) return;
    const wrap = (inc || dec).closest('.qty');
    const input = wrap?.querySelector('input');
    if (!input) return;
    let v = parseInt(input.value || '1', 10);
    v += inc ? 1 : -1;
    if (v < 1) v = 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- PDP variant picker ---------- */
  const pdp = $('#PadelitProduct');
  if (pdp) {
    let variants = [];
    const vData = $('[data-pdp-variants]', pdp) || $('[data-pdp-variants]');
    try { variants = JSON.parse(vData.textContent); } catch (e) { variants = []; }
    const idInput = $('[data-variant-id]', pdp);
    const priceWrap = $('[data-pdp-price]', pdp);
    const stickyPrice = $('[data-pdp-sticky-price]', pdp);
    const stickyVarTitle = $('[data-pdp-variant-title]', pdp);
    const atcBtn = $('[data-atc]', pdp);
    const atcText = $('[data-atc-text]', pdp);
    const mainImg = $('#PdpMainImage');
    const optGroups = $$('.pdp__opt [data-option-position]', pdp);

    const selectedOptions = () => optGroups.map(g => {
      const a = g.querySelector('button.active');
      return a ? a.dataset.optionValue : null;
    });
    const findVariant = opts => variants.find(v =>
      v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));

    function updateVariant() {
      let v;
      if (optGroups.length === 0) {
        v = variants.find(x => x.available) || variants[0];
      } else {
        v = findVariant(selectedOptions());
      }
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceWrap) priceWrap.innerHTML =
        '<span class="now">' + v.price + '</span>' +
        (v.onSale ? '<span class="was">' + v.compare + '</span><span class="off">-' + v.off + '%</span>' : '');
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (stickyVarTitle) stickyVarTitle.textContent = v.title;
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (v.image) {
        if (typeof window.pdltGalleryShowSrc === 'function') window.pdltGalleryShowSrc(v.image);
        else if (mainImg) mainImg.src = v.image;
      }
    }

    optGroups.forEach(group => {
      group.addEventListener('click', e => {
        const btn = e.target.closest('button');
        if (!btn) return;
        group.querySelectorAll('button').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const pos = group.dataset.optionPosition;
        const label = pdp.querySelector('[data-option-label="' + pos + '"]');
        if (label && btn.dataset.label) label.textContent = btn.dataset.label;
        updateVariant();
      });
    });
    updateVariant();

    // Buy now: add the selected variant, then go to checkout
    // const buyNow = $('[data-buynow]', pdp);
    // const pForm = document.getElementById('PadelitProductForm');
    // if (buyNow && pForm) {
    //   buyNow.addEventListener('click', () => {
    //     if (buyNow.hasAttribute('disabled')) return;
    //     const qtyEl = pForm.querySelector('[name="quantity"]');
    //     buyNow.textContent = 'Adding…';
    //     fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyEl && qtyEl.value || '1', 10) })
    //     }).then(() => { window.location.href = '/checkout'; })
    //       .catch(() => { window.location.href = '/cart'; });
    //   });
    // }
  // Buy now: let Breeze handle the selected product
const buyNow = $('[data-buynow]', pdp);
const pForm = document.getElementById('PadelitProductForm');

if (buyNow && pForm) {
  buyNow.addEventListener('click', (e) => {
    e.preventDefault();

    if (buyNow.disabled || buyNow.hasAttribute('disabled')) return;

    const qtyEl = pForm.querySelector('[name="quantity"]');
    const variantId = idInput?.value;
    const quantity = parseInt(qtyEl?.value || '1', 10);

    if (!variantId) return;

    // Pass the selected product to Breeze's Buy Now handler
    if (window.breeze?.prefillData) {
      window.breeze.prefillData({
        variantId: variantId,
        quantity: quantity
      });
    }

    if (window.breeze?.startCheckout) {
      window.breeze.startCheckout();
    }
  });
}

  }

  /* ---------- PDP gallery: thumbs + arrows + fullscreen lightbox ---------- */
  (function () {
    const gallery = $('.gallery');
    if (!gallery) return;
    const main = document.getElementById('PdpMainImage');
    const thumbs = $$('.thumbs button', gallery);
    const srcs = thumbs.map(b => b.dataset.src).filter(Boolean);
    const lb = document.getElementById('pdpLightbox');
    // Move the lightbox to <body> so position:fixed covers the whole viewport
    // (a transformed/overflow ancestor on the PDP otherwise traps it).
    if (lb && lb.parentNode !== document.body) document.body.appendChild(lb);
    const lbImg = lb && lb.querySelector('.pdp-lightbox__img');
    let idx = 0;

    function show(i) {
      if (!srcs.length) return;
      idx = (i + srcs.length) % srcs.length;
      if (main) main.src = srcs[idx];
      thumbs.forEach((t, k) => t.classList.toggle('active', k === idx));
      if (lbImg && lb.classList.contains('is-open')) lbImg.src = srcs[idx];
    }
    thumbs.forEach((b, k) => b.addEventListener('click', () => show(k)));
    $$('[data-gal-prev]', gallery).forEach(b => b.addEventListener('click', () => show(idx - 1)));
    $$('[data-gal-next]', gallery).forEach(b => b.addEventListener('click', () => show(idx + 1)));

    // Let the variant picker drive the gallery: selecting a colour swatch jumps
    // to that variant's image AND moves the active thumb, so the arrows carry on
    // from the right place instead of snapping back to the old index.
    window.pdltGalleryShowSrc = function (src) {
      if (!src) return false;
      const base = u => (u || '').split('?')[0].replace(/(_|\.)(\d+x\d+)(?=\.)/, '');
      let i = srcs.findIndex(u => base(u) === base(src));
      if (i < 0) {
        const f = s => (s || '').split('/').pop().split('?')[0].replace(/_\d+x\d+/, '');
        i = srcs.findIndex(u => f(u) === f(src));
      }
      if (i >= 0) { show(i); return true; }
      if (main) main.src = src;          // variant image not among the thumbs
      return false;
    };

    // Vertical thumb strip (desktop): show a down arrow while there are more
    // images below, and an up arrow once the customer has scrolled away from the top.
    (function () {
      const col = gallery.querySelector('.thumbs-col');
      const strip = gallery.querySelector('.thumbs');
      const up = gallery.querySelector('[data-thumbs-up]');
      const down = gallery.querySelector('[data-thumbs-down]');
      if (!col || !strip || !up || !down) return;
      const step = () => {
        const first = strip.querySelector('button');
        const h = first ? first.getBoundingClientRect().height + 10 : 90;
        return Math.max(h * 3, h);
      };
      function sync() {
        const scrollable = strip.scrollHeight - strip.clientHeight > 2;
        const atTop = strip.scrollTop <= 2;
        const atEnd = strip.scrollTop + strip.clientHeight >= strip.scrollHeight - 2;
        up.hidden = !scrollable || atTop;
        down.hidden = !scrollable || atEnd;
      }
      up.addEventListener('click', () => strip.scrollBy({ top: -step(), behavior: 'smooth' }));
      down.addEventListener('click', () => strip.scrollBy({ top: step(), behavior: 'smooth' }));
      strip.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      if (window.ResizeObserver) new ResizeObserver(sync).observe(strip);
      // keep the active thumb in view when the variant/arrows change the image
      const obs = new MutationObserver(() => {
        const act = strip.querySelector('button.active');
        if (act) act.scrollIntoView({ block: 'nearest' });
        sync();
      });
      thumbs.forEach(t => obs.observe(t, { attributes: true, attributeFilter: ['class'] }));
      sync();
      setTimeout(sync, 400);   // re-check once lazy thumbs have laid out
    })();

    function openLb() {
      if (!lb) return;
      if (lbImg) lbImg.src = srcs[idx] || (main && main.src) || '';
      lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeLb() {
      if (!lb) return;
      lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    $$('[data-pdp-zoom]').forEach(b => b.addEventListener('click', openLb));
    if (main) main.addEventListener('click', openLb);
    if (lb) {
      $$('[data-lb-close]', lb).forEach(b => b.addEventListener('click', closeLb));
      $$('[data-lb-prev]', lb).forEach(b => b.addEventListener('click', () => show(idx - 1)));
      $$('[data-lb-next]', lb).forEach(b => b.addEventListener('click', () => show(idx + 1)));
      document.addEventListener('keydown', e => {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
      });
    }
  })();

  /* ---------- Tabs ---------- */
  $$('.tabs').forEach(tabs => {
    tabs.addEventListener('click', e => {
      const btn = e.target.closest('.tabs__head button');
      if (!btn) return;
      tabs.querySelectorAll('.tabs__head button').forEach(b => b.classList.remove('active'));
      tabs.querySelectorAll('.tabs__panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      tabs.querySelector(`#${btn.dataset.panel}`)?.classList.add('active');
    });
  });

  /* ---------- Sticky ATC (PDP) ---------- */
  const stickyAtc = $('.sticky-atc');
  const atcTrigger = $('.pdp__buybar') || $('.pdp__actions');
  if (stickyAtc && atcTrigger && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0 });
    io.observe(atcTrigger);
  }

  /* ---------- Filter chips remove (collection) ---------- */
  document.addEventListener('click', e => {
    const x = e.target.closest('.chip button');
    if (x) x.closest('.chip').remove();
  });

  /* ---------- Mobile filter drawer (collection) ---------- */
  const filters = $('#filters');
  const openFilters = () => {
    if (!filters) return;
    filters.classList.add('is-open');
    scrim?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeFilters = () => {
    filters?.classList.remove('is-open');
    if (!$$('.drawer.is-open').length) {
      scrim?.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  };
  // Delegated, not bound per element: both buttons live inside regions the AJAX
  // filter refresh replaces (close in [data-pjax="filters"], open in
  // [data-pjax="results"]), so directly-bound listeners were thrown away after the
  // first filter action and the drawer could no longer be opened or closed.
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-filters]')) openFilters();
    else if (e.target.closest('[data-close-filters]')) closeFilters();
  });
  // Reuse global scrim click handler — already calls closeDrawers, also close filters
  scrim?.addEventListener('click', closeFilters);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeFilters(); });

  /* ---------- Wishlist (localStorage) ---------- */
  const Wishlist = (() => {
    const KEY = 'padelit:wishlist';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
    const write = arr => { localStorage.setItem(KEY, JSON.stringify(arr)); document.dispatchEvent(new CustomEvent('padelit:wishlist:change', { detail: arr })); };
    const has = handle => read().some(i => i.handle === handle);
    const toggle = item => {
      const arr = read();
      const idx = arr.findIndex(i => i.handle === item.handle);
      if (idx > -1) arr.splice(idx, 1); else arr.unshift(item);
      write(arr);
      return idx === -1; // true if added
    };
    const remove = handle => { write(read().filter(i => i.handle !== handle)); };
    const clear = () => write([]);
    return { read, has, toggle, remove, clear, count: () => read().length };
  })();
  window.PadelitWishlist = Wishlist;

  function wlUpdateBadges() {
    const n = Wishlist.count();
    $$('[data-wishlist-count]').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }
  function wlUpdateHearts() {
    $$('.pcard__wish[data-wl-handle]').forEach(w => {
      const on = Wishlist.has(w.getAttribute('data-wl-handle'));
      w.classList.toggle('is-on', on);
      w.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // Toggle from any product card heart (stop the card link from firing)
  document.addEventListener('click', e => {
    const w = e.target.closest('.pcard__wish');
    if (!w) return;
    e.preventDefault();
    e.stopPropagation();
    if (!w.hasAttribute('data-wl-handle')) { w.classList.toggle('is-on'); return; }
    Wishlist.toggle({
      handle: w.getAttribute('data-wl-handle'),
      title: w.getAttribute('data-wl-title') || '',
      url: w.getAttribute('data-wl-url') || '#',
      brand: w.getAttribute('data-wl-brand') || '',
      price: w.getAttribute('data-wl-price') || '',
      image: w.getAttribute('data-wl-image') || ''
    });
  });

  // Wishlist page renderer
  function wlRenderPage() {
    const grid = $('#WishlistGrid');
    if (!grid) return;
    const items = Wishlist.read();
    const empty = $('#WishlistEmpty');
    const count = $('#WishlistCount');
    if (count) count.textContent = items.length;
    if (empty) empty.style.display = items.length ? 'none' : '';
    grid.innerHTML = items.map(i => `
      <div class="pcard" data-wl-card="${i.handle}">
        <a href="${i.url}" class="pcard__media">
          ${i.image ? `<img src="${i.image}" alt="${i.title}" loading="lazy">` : ''}
          <button type="button" class="pcard__wish is-on" data-wl-remove="${i.handle}" aria-label="Remove from wishlist">
            <svg class="ico ico-sm" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
          </button>
        </a>
        <div class="pcard__body">
          ${i.brand ? `<span class="pcard__brand">${i.brand}</span>` : ''}
          <a href="${i.url}"><h3 class="pcard__title">${i.title}</h3></a>
          <div class="pcard__price"><span class="now">${i.price}</span></div>
        </div>
      </div>`).join('');
  }

  // Remove from the wishlist page
  document.addEventListener('click', e => {
    const r = e.target.closest('[data-wl-remove]');
    if (!r) return;
    e.preventDefault();
    e.stopPropagation();
    Wishlist.remove(r.getAttribute('data-wl-remove'));
  });
  // Clear all
  document.addEventListener('click', e => {
    if (e.target.closest('[data-wl-clear]')) { e.preventDefault(); Wishlist.clear(); }
  });

  // React to any wishlist change + initial paint
  document.addEventListener('padelit:wishlist:change', () => { wlUpdateBadges(); wlUpdateHearts(); wlRenderPage(); });
  window.addEventListener('storage', e => { if (e.key === 'padelit:wishlist') { wlUpdateBadges(); wlUpdateHearts(); wlRenderPage(); } });
  wlUpdateBadges(); wlUpdateHearts(); wlRenderPage();

  /* ---------- Search demo (collection) ---------- */
  /* ---------- Predictive search (debounced) ---------- */
  const searchInput = $('#searchInput');
  const searchResults = $('[data-search-results]');
  const searchDefault = $('[data-search-default]');
  if (searchInput && searchResults) {
    let t, lastQ = '';
    const showDefault = () => { searchResults.hidden = true; searchResults.innerHTML = ''; if (searchDefault) searchDefault.style.display = ''; };
    const run = q => {
      searchResults.classList.add('is-loading');
      fetch('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=padelit-predictive-search&resources[type]=product,query,collection&resources[limit]=10')
        .then(r => r.text())
        .then(html => {
          if (searchInput.value.trim() !== q) return; // stale
          searchResults.innerHTML = html;
          searchResults.hidden = false;
          searchResults.classList.remove('is-loading');
          if (searchDefault) searchDefault.style.display = 'none';
        })
        .catch(() => { searchResults.classList.remove('is-loading'); });
    };
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.trim();
      clearTimeout(t);
      if (q.length < 2) { lastQ = ''; showDefault(); return; }
      if (q === lastQ) return;
      lastQ = q;
      t = setTimeout(() => run(q), 250);
    });
  }

  /* ---------- Collection filters: AJAX, swatches, sort, show-more ---------- */
  const collRoot = $('#PadelitCollection');
  if (collRoot) {
    const sectionId = collRoot.dataset.sectionId;
    let reqToken = 0;

    const navigate = (url, push) => {
      // Every filter action (checkbox, swatch, price apply, clear, chip) closes the
      // mobile drawer so the shopper sees the results update. No-op on desktop,
      // where the filters are a sidebar rather than a drawer.
      if (typeof closeFilters === 'function') closeFilters();
      const token = ++reqToken;
      collRoot.classList.add('is-loading');
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      fetch(fetchUrl.toString())
        .then(r => r.text())
        .then(html => {
          if (token !== reqToken) return; // a newer request superseded this one
          const doc = new DOMParser().parseFromString(html, 'text/html');
          ['filters', 'results'].forEach(key => {
            const fresh = doc.querySelector('[data-pjax="' + key + '"]');
            const cur = collRoot.querySelector('[data-pjax="' + key + '"]');
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
          if (push) {
            const clean = new URL(url, window.location.origin);
            clean.searchParams.delete('section_id');
            history.pushState({ padelit: true }, '', clean.toString());
          }
          collRoot.classList.remove('is-loading');
          bind();
          const top = collRoot.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: top, behavior: 'smooth' });
        })
        .catch(() => { window.location.href = url; });
    };

    function bind() {
      // checkbox rows + swatches
      collRoot.querySelectorAll('[data-filter-url]').forEach(el => {
        el.onclick = e => {
          if (el.hasAttribute('disabled')) return;
          e.preventDefault();
          navigate(el.getAttribute('data-filter-url'), true);
        };
      });
      // plain pjax links (chips, pagination, clear, reset)
      collRoot.querySelectorAll('a[data-pjax-link]').forEach(a => {
        a.onclick = e => { e.preventDefault(); navigate(a.getAttribute('href'), true); };
      });
      // price form
      collRoot.querySelectorAll('form[data-pjax-form]').forEach(f => {
        f.onsubmit = e => {
          e.preventDefault();
          const params = new URLSearchParams(new FormData(f));
          navigate(window.location.pathname + '?' + params.toString(), true);
        };
      });
      // sort
      const sortBy = collRoot.querySelector('#SortBy');
      if (sortBy) sortBy.onchange = () => {
        const u = new URL(window.location.href);
        u.searchParams.set('sort_by', sortBy.value);
        u.searchParams.delete('page');
        navigate(u.toString(), true);
      };
      // show more / less
      collRoot.querySelectorAll('[data-showmore]').forEach(btn => {
        btn.onclick = () => {
          const list = btn.closest('.filter-list');
          const open = list.classList.toggle('is-expanded');
          btn.textContent = open ? 'Show less' : ('Show all ' + (list.querySelectorAll('.filter-opt').length));
        };
      });
    }

    bind();
    window.addEventListener('popstate', () => navigate(window.location.href, false));
  }

  /* ---------- AJAX Cart (add / update / drawer) ---------- */
  const CART_SECTION = 'padelit-cart-drawer';

  function pdltRefreshCart(html) {
    const cur = document.getElementById('cartDrawer');
    if (cur && html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#cartDrawer');
      if (fresh) cur.innerHTML = fresh.innerHTML;
    }
    const cEl = cur && cur.querySelector('[data-cart-count]');
    const n = cEl ? parseInt(cEl.textContent, 10) : 0;
    $$('[data-cart-badge]').forEach(b => { b.textContent = n; b.style.display = n > 0 ? '' : 'none'; });
  }

  function pdltAddToCart(id, qty, btn, onDone) {
    if (!id) return;
    pdltAddItems([{ id: id, quantity: qty || 1 }], btn, onDone);
  }
  function pdltAddItems(items, btn, onDone) {
    items = (items || []).filter(function (i) { return i && i.id; });
    if (!items.length) return;
    const orig = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: CART_SECTION, sections_url: window.location.pathname })
    }).then(r => r.json().then(d => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (!ok) throw new Error((d && d.description) || 'add failed');
        pdltRefreshCart(d.sections && d.sections[CART_SECTION]);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.disabled = false;
          const lbl = btn.querySelector('[data-atc-text]') || btn;
          const prev = lbl.textContent;
          lbl.textContent = 'ADDED ✓';
          setTimeout(() => { btn.classList.remove('is-added'); lbl.textContent = prev; }, 1600);
        }
        if (typeof onDone === 'function') onDone();
        openDrawer('cartDrawer');
      })
      .catch(() => {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; btn.innerHTML = orig; }
        window.location.href = '/cart';
      });
  }

  function pdltRefreshEl(elId, html) {
    const cur = document.getElementById(elId);
    if (!cur || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#' + elId);
    if (fresh) cur.innerHTML = fresh.innerHTML;
  }

  function pdltUpdateLine(line, qty) {
    const drawer = document.getElementById('cartDrawer');
    const onCartPage = !!document.getElementById('PadelitCartPage');
    if (drawer) drawer.classList.add('is-loading');
    if (onCartPage) document.getElementById('PadelitCartPage').classList.add('is-loading');
    const secs = onCartPage ? CART_SECTION + ',padelit-cart' : CART_SECTION;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty, sections: secs, sections_url: window.location.pathname })
    }).then(r => r.json()).then(d => {
      if (d.sections) {
        pdltRefreshCart(d.sections[CART_SECTION]);
        if (onCartPage) pdltRefreshEl('PadelitCartPage', d.sections['padelit-cart']);
      }
    }).catch(() => {}).finally(() => {
      if (drawer) drawer.classList.remove('is-loading');
      const cp = document.getElementById('PadelitCartPage');
      if (cp) cp.classList.remove('is-loading');
    });
  }

  // Discount code on the cart page -> Shopify /discount route
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-cart-discount]');
    if (!f) return;
    e.preventDefault();
    const inp = f.querySelector('input[name="discount"]');
    const code = inp && inp.value.trim();
    if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
  });

  // Quick add on product cards
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault(); e.stopPropagation();
    pdltAddToCart(q.getAttribute('data-variant-id'), 1, q);
  });

  // Cart drawer qty steppers + remove
  document.addEventListener('click', e => {
    const minus = e.target.closest('[data-cart-minus]');
    const plus = e.target.closest('[data-cart-plus]');
    const rem = e.target.closest('[data-cart-remove]');
    if (minus || plus) {
      const wrap = (minus || plus).closest('[data-cart-line]');
      const input = wrap && wrap.querySelector('[data-cart-qty]');
      if (!input) return;
      let v = parseInt(input.value || '1', 10) + (plus ? 1 : -1);
      if (v < 0) v = 0;
      pdltUpdateLine(input.getAttribute('data-line'), v);
    } else if (rem) {
      pdltUpdateLine(rem.getAttribute('data-cart-remove'), 0);
    }
  });
  document.addEventListener('change', e => {
    const inp = e.target.closest('[data-cart-qty]');
    if (inp) pdltUpdateLine(inp.getAttribute('data-line'), parseInt(inp.value || '0', 10));
  });

  // PDP add-to-cart form -> AJAX add + open drawer
  // checked combo add-ons → [{id, quantity:1}, ...]
  function comboItems() {
    return $$('[data-combo-item]:checked').map(cb => ({ id: cb.value, quantity: 1 }));
  }
  const pdpForm = document.getElementById('PadelitProductForm');
  if (pdpForm) {
    pdpForm.addEventListener('submit', e => {
      e.preventDefault();
      const idEl = pdpForm.querySelector('[name="id"]');
      const qtyEl = pdpForm.querySelector('[name="quantity"]');
      const btn = e.submitter || pdpForm.querySelector('[data-atc]');
      const items = [{ id: idEl && idEl.value, quantity: parseInt((qtyEl && qtyEl.value) || '1', 10) }].concat(comboItems());
      pdltAddItems(items, btn);
    });
  }

  /* ---------- Combo / "Complete the kit" ---------- */
  const combo = $('[data-combo]');
  if (combo) {
    const mainPrice = parseInt(combo.getAttribute('data-main-price') || '0', 10);
    const totalEl = combo.querySelector('[data-combo-total]');
    function fmt(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }
    function recalc() {
      let t = mainPrice;
      $$('[data-combo-item]:checked', combo).forEach(cb => { t += parseInt(cb.getAttribute('data-price') || '0', 10); });
      if (totalEl) totalEl.textContent = fmt(t);
    }
    combo.addEventListener('change', e => { if (e.target.closest('[data-combo-item]')) recalc(); });
    recalc();
    const addBtn = combo.querySelector('[data-combo-add]');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        const idEl = pdpForm && pdpForm.querySelector('[name="id"]');
        const qtyEl = pdpForm && pdpForm.querySelector('[name="quantity"]');
        const items = [{ id: idEl && idEl.value, quantity: parseInt((qtyEl && qtyEl.value) || '1', 10) }].concat(comboItems());
        pdltAddItems(items, addBtn);
      });
    }
  }

  /* ---------- Quick-view popup (variant products) ---------- */
  const qaModal = document.getElementById('quickAddModal');
  const qaBody = qaModal && qaModal.querySelector('[data-qa-body]');

  function qaOpen() { qaModal.classList.add('is-open'); qaModal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function qaClose() { if (!qaModal) return; qaModal.classList.remove('is-open'); qaModal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (qaBody) qaBody.innerHTML = ''; }

  function qaBind() {
    const card = qaBody.querySelector('[data-qa-card]');
    if (!card) return;
    let variants = [];
    try { variants = JSON.parse(card.querySelector('[data-qa-variants]').textContent); } catch (e) { variants = []; }
    const idInput = card.querySelector('[data-qa-variant]');
    const priceEl = card.querySelector('[data-qa-price]');
    const addBtn = card.querySelector('[data-qa-add]');
    const img = card.querySelector('#QaMainImage');
    const groups = [...card.querySelectorAll('[data-option-position]')];

    const selected = () => groups.map(g => { const a = g.querySelector('button.active'); return a ? a.dataset.optionValue : null; });
    const match = opts => variants.find(v => v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));

    function upd() {
      const v = groups.length ? match(selected()) : (variants.find(x => x.available) || variants[0]);
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = '<span class="now">' + v.price + '</span>' + (v.onSale ? '<span class="was">' + v.compare + '</span>' : '');
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT'; }
      if (img && v.image) img.src = v.image;
    }
    groups.forEach(g => g.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      g.querySelectorAll('button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      const lbl = card.querySelector('[data-option-label="' + g.dataset.optionPosition + '"]');
      if (lbl && b.dataset.label) lbl.textContent = b.dataset.label;
      upd();
    }));
    upd();
    if (addBtn) addBtn.addEventListener('click', () => {
      if (addBtn.disabled) return;
      const qtyEl = card.querySelector('[data-qa-qty]');
      // loader shows on the popup button; the modal closes only once the add completes
      pdltAddToCart(idInput.value, parseInt((qtyEl && qtyEl.value) || '1', 10), addBtn, qaClose);
    });
  }

  document.addEventListener('click', e => {
    const qv = e.target.closest('[data-quick-view]');
    if (qv) {
      e.preventDefault(); e.stopPropagation();
      if (!qaBody) { window.location.href = '/products/' + qv.getAttribute('data-product-handle'); return; }
      const handle = qv.getAttribute('data-product-handle');
      qv.classList.add('is-loading');
      fetch('/products/' + handle + '?view=quick-add')
        .then(r => r.text())
        .then(html => { qaBody.innerHTML = html; qv.classList.remove('is-loading'); qaOpen(); qaBind(); })
        .catch(() => { qv.classList.remove('is-loading'); window.location.href = '/products/' + handle; });
      return;
    }
    // Combo "eye" — view-only quick view (no ATC; selection is via the checkbox)
    const cvBtn = e.target.closest('[data-combo-view]');
    if (cvBtn) {
      e.preventDefault(); e.stopPropagation();
      const handle = cvBtn.getAttribute('data-handle');
      if (!qaBody) { window.location.href = '/products/' + handle; return; }
      cvBtn.classList.add('is-loading');
      fetch('/products/' + handle + '?view=quick-view')
        .then(r => r.text())
        .then(html => { qaBody.innerHTML = html; cvBtn.classList.remove('is-loading'); qaOpen(); qvBindThumbs(); })
        .catch(() => { cvBtn.classList.remove('is-loading'); window.location.href = '/products/' + handle; });
      return;
    }
    if (e.target.closest('[data-qa-close]')) qaClose();
  });
  // thumbnail swap inside the view-only quick view
  function qvBindThumbs() {
    const main = qaBody && qaBody.querySelector('#QvMainImage');
    if (!main) return;
    $$('.qv-thumbs button', qaBody).forEach(b => {
      b.addEventListener('click', () => {
        $$('.qv-thumbs button', qaBody).forEach(t => t.classList.remove('active'));
        b.classList.add('active');
        if (b.dataset.qvSrc) main.src = b.dataset.qvSrc;
      });
    });
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && qaModal && qaModal.classList.contains('is-open')) qaClose(); });

  /* ---------- Generic content modal (brand story, etc.) ---------- */
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) {
      e.preventDefault();
      const m = document.getElementById(opener.getAttribute('data-modal-open'));
      if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      return;
    }
    const closer = e.target.closest('.content-modal [data-modal-close]');
    if (closer) {
      const m = closer.closest('.content-modal');
      if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    $$('.content-modal.is-open').forEach(m => { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; });
  });
})();

/* ============================================================
   INTERACTIVE QUIZ FINDER
   ============================================================ */
(function () {
  function initQuiz(root) {
    var startBtns = root.querySelectorAll('[data-quiz-start]');
    var flow = root.querySelector('[data-quiz-flow]');
    var intro = root.querySelector('[data-quiz-intro]');
    var resultMsg = root.querySelector('[data-quiz-resultmsg]');
    var defaultVisual = root.querySelector('[data-quiz-default]');
    var questions = Array.prototype.slice.call(root.querySelectorAll('[data-q]'));
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-result]'));
    if (!questions.length || !flow) return;

    var idx = 0;
    var scores = {};
    var priority = ['control', 'power', 'hybrid'];

    function showQuestion(i) {
      questions.forEach(function (q, qi) { q.hidden = qi !== i; });
      steps.forEach(function (s, si) { s.classList.toggle('active', si <= i); });
    }
    function start(e) {
      if (e) e.preventDefault();
      idx = 0; scores = {};
      root.classList.remove('quiz--result');
      if (intro) intro.hidden = true;
      if (resultMsg) resultMsg.hidden = true;
      if (defaultVisual) defaultVisual.hidden = false;
      panels.forEach(function (p) { p.hidden = true; });
      flow.hidden = false;
      showQuestion(0);
    }
    function answer(profile) {
      if (profile) scores[profile] = (scores[profile] || 0) + 1;
      idx++;
      if (idx < questions.length) showQuestion(idx);
      else finish();
    }
    function finish() {
      // Highest score wins. A genuine tie (e.g. 1 control / 1 power / 1 hybrid)
      // means a mixed game, so it resolves to the all-rounder rather than silently
      // falling through to whichever profile happens to be listed first.
      var max = -1;
      priority.forEach(function (p) { max = Math.max(max, scores[p] || 0); });
      var top = priority.filter(function (p) { return (scores[p] || 0) === max; });
      var winner = top.length === 1 ? top[0] : 'hybrid';
      var panel = null;
      panels.forEach(function (p) { if (!panel && p.getAttribute('data-result') === winner) panel = p; });
      if (!panel) panel = panels[0];

      flow.hidden = true;
      if (intro) intro.hidden = true;
      root.classList.add('quiz--result');
      if (defaultVisual) defaultVisual.hidden = true;
      panels.forEach(function (p) { p.hidden = p !== panel; });
      steps.forEach(function (s) { s.classList.add('active'); });
      if (window.__pdltRefreshCarousels) requestAnimationFrame(window.__pdltRefreshCarousels);

      if (panel && resultMsg) {
        var t = resultMsg.querySelector('[data-result-title]');
        var d = resultMsg.querySelector('[data-result-text]');
        if (t) t.textContent = panel.getAttribute('data-title') || 'Your perfect match';
        if (d) d.textContent = panel.getAttribute('data-text') || '';
        resultMsg.hidden = false;
      }
    }

    startBtns.forEach(function (b) { b.addEventListener('click', start); });
    root.querySelectorAll('[data-quiz-opt]').forEach(function (b) {
      b.addEventListener('click', function () { answer(b.getAttribute('data-profile')); });
    });
    root.querySelectorAll('[data-quiz-restart]').forEach(function (b) {
      b.addEventListener('click', start);
    });
  }

  // Result carousel: edge-aware arrow visibility
  function updateCar(wrap) {
    var car = wrap.querySelector('[data-carousel]');
    if (!car || !car.clientWidth) return;
    wrap.classList.toggle('at-start', car.scrollLeft <= 2);
    wrap.classList.toggle('at-end', car.scrollLeft + car.clientWidth >= car.scrollWidth - 2);
  }
  function refreshCarousels() {
    document.querySelectorAll('.quiz__carousel-wrap').forEach(updateCar);
  }
  document.addEventListener('scroll', function (e) {
    var car = e.target.closest && e.target.closest('[data-carousel]');
    if (car) updateCar(car.closest('.quiz__carousel-wrap'));
  }, true);
  window.addEventListener('resize', refreshCarousels);

  // Result carousel prev/next
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-car-prev]');
    var next = e.target.closest('[data-car-next]');
    if (!prev && !next) return;
    var wrap = (prev || next).closest('.quiz__carousel-wrap');
    var car = wrap && wrap.querySelector('[data-carousel]');
    if (!car) return;
    var step = Math.min(car.clientWidth * 0.85, 528);
    car.scrollBy({ left: (next ? 1 : -1) * step, behavior: 'smooth' });
  });
  // expose so the quiz can refresh arrows right after revealing a result
  window.__pdltRefreshCarousels = refreshCarousels;

  function boot() {
    document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ============================================================
   QUIZ VISUAL — scroll-linked spin + round (GSAP ScrollTrigger)
   Box rounds to a circle and the racket sunburst spins like a
   rolling tyre as you scroll (reverses on scroll up).
   ============================================================ */
(function () {
  function initQuizScroll() {
    if (!window.gsap || !window.ScrollTrigger) return;                 // CDN not loaded -> no-op
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gsap.registerPlugin(ScrollTrigger);                                // runs on mobile too (box is now square)
    document.querySelectorAll('[data-quiz]').forEach(function (q) {
      var visual = q.querySelector('[data-quiz-visual]');
      if (!visual) return;
      var tl = gsap.timeline({
        scrollTrigger: { trigger: q, start: 'top 80%', end: 'bottom top', scrub: 1 }
      });
      // box rounds into a circle first, then the whole wheel spins like a rolling tyre
      // (rotating the box, not just the image, keeps it gap-free with no background)
      tl.fromTo(visual, { borderRadius: '8%' }, { borderRadius: '50%', ease: 'none', duration: 0.1 }, 0);
      tl.fromTo(visual, { rotation: 0 }, { rotation: 180, ease: 'none', duration: 0.9 }, 0.1);
    });
  }
  if (document.readyState === 'complete') initQuizScroll();
  else window.addEventListener('load', initQuizScroll);
  window.addEventListener('padelit:gsap', initQuizScroll);   // GSAP is loaded lazily; re-run when it lands
})();

/* ============================================================
   HOME — scroll reveal (GSAP). Sections fade + rise as they
   enter the viewport, reverse on scroll back up. Home only,
   reduced-motion safe, no-op if GSAP CDN missing.
   ============================================================ */
(function () {
  function initReveal() {
    if (!window.gsap || !window.ScrollTrigger) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!document.body.classList.contains('padelit-template-index')) return;
    gsap.registerPlugin(ScrollTrigger);
    var vh = window.innerHeight;
    gsap.utils.toArray('.padelit-section').forEach(function (sec) {
      // skip sections already on screen at load (e.g. hero) so they don't flash hidden
      if (sec.getBoundingClientRect().top < vh * 0.85) return;
      gsap.from(sec, {
        opacity: 0, y: 48, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: sec, start: 'top 82%', toggleActions: 'play none none reverse' }
      });
    });
  }
  if (document.readyState === 'complete') initReveal();
  else window.addEventListener('load', initReveal);
  window.addEventListener('padelit:gsap', initReveal);       // ditto
})();

/* ============================================================
   COLLECTION FILTERS — smooth animated accordion (GSAP).
   Falls back to native <details> toggle when GSAP/reduced-motion.
   Delegated so it survives the AJAX filter re-render.
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var sum = e.target.closest('.filter-group > summary');
    if (!sum) return;
    if (!window.gsap || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // native handles it
    var det = sum.parentElement;
    var body = det.querySelector('.filter-group__body');
    if (!body) return;
    e.preventDefault();
    if (det.open) {
      gsap.to(body, {
        height: 0, opacity: 0, duration: 0.26, ease: 'power2.inOut',
        onComplete: function () { det.open = false; gsap.set(body, { clearProps: 'height,opacity,overflow' }); }
      });
    } else {
      det.open = true;
      gsap.set(body, { height: 'auto', opacity: 1 });
      gsap.from(body, {
        height: 0, opacity: 0, duration: 0.3, ease: 'power2.out',
        onComplete: function () { gsap.set(body, { clearProps: 'height' }); }
      });
    }
  });
})();

/* ============================================================
   COPY FIX — "Racquet(s)" -> "Racket(s)" everywhere (incl. admin
   text: products, pages, policies, nav). Case-preserving. Only
   touches visible text nodes (never URLs/attributes/inputs).
   ============================================================ */
(function () {
  var TEST = /racquet/i;
  var REPL = /racquet/gi;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, INPUT: 1, CODE: 1, PRE: 1 };
  function swap(m) {
    if (m === m.toUpperCase()) return 'RACKET';
    if (m[0] === m[0].toUpperCase()) return 'Racket';
    return 'racket';
  }
  function fixNode(n) { if (TEST.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(REPL, swap); }
  function walk(root) {
    if (!root || root.nodeType !== 1) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !TEST.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (n.parentNode && SKIP[n.parentNode.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var batch = [], cur;
    while ((cur = tw.nextNode())) batch.push(cur);
    batch.forEach(fixNode);
  }
  function run() {
    walk(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (node.nodeType === 3) fixNode(node);
          else walk(node);
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* ============================================================
   TESTIMONIALS — auto-rotating slider (~7s). Pauses on hover,
   loops to start, skips on reduced-motion (manual scroll still works).
   ============================================================ */
(function () {
  function init() {
    document.querySelectorAll('[data-testimonials]').forEach(function (track) {
      if (track.children.length <= 3) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var timer = null;
      function step() {
        var card = track.children[0];
        var gap = 18;
        var w = card ? card.getBoundingClientRect().width + gap : 320;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: w, behavior: 'smooth' });
        }
      }
      function start() { stop(); timer = setInterval(step, 7000); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      track.addEventListener('mouseenter', stop);
      track.addEventListener('mouseleave', start);
      track.addEventListener('focusin', stop);
      track.addEventListener('focusout', start);
      start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================
   WHATSAPP WIDGET — toggle the quick-question popup
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-wa-toggle]');
    var widget = document.querySelector('[data-wa]');
    if (!widget) return;
    var pop = widget.querySelector('[data-wa-pop]');
    var fab = widget.querySelector('.wa-fab');
    if (toggle) {
      var open = widget.classList.toggle('is-open');
      if (pop) pop.hidden = false; // keep in DOM; CSS handles visibility
      if (fab) fab.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    // click outside closes
    if (widget.classList.contains('is-open') && !e.target.closest('[data-wa]')) {
      widget.classList.remove('is-open');
      if (fab) fab.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var w = document.querySelector('[data-wa].is-open');
    if (w) { w.classList.remove('is-open'); var f = w.querySelector('.wa-fab'); if (f) f.setAttribute('aria-expanded', 'false'); }
  });
})();

/* ============================================================
   PAGE PRELOADER — hide when the page is ready
   ============================================================ */
(function () {
  var pl = document.getElementById('preloader');
  if (!pl) return;
  var MIN = 500; // keep it visible at least this long so it doesn't just flicker
  var start = Date.now();
  var done = false;
  function hide() {
    if (done) return; done = true;
    var wait = Math.max(0, MIN - (Date.now() - start));
    setTimeout(function () {
      document.documentElement.classList.add('pl-done');
      document.body && (document.body.style.overflow = '');
    }, wait);
  }
  // prevent scroll under the loader while visible
  try { document.body.style.overflow = 'hidden'; } catch (e) {}
  if (document.readyState === 'complete') hide();
  else window.addEventListener('load', hide);
  setTimeout(hide, 4000); // safety: never get stuck
  // bfcache restore (back/forward) — make sure it's hidden
  window.addEventListener('pageshow', function (e) { if (e.persisted) { document.documentElement.classList.add('pl-done'); document.body && (document.body.style.overflow = ''); } });
})();

/* ============================================================
   PDP SPEC METAFIELD — parse run-on "characteristics" rich text
   ("Shape: DiamondCore: X-EVAMaterial: 3K Carbon…") into a clean
   key/value spec table by splitting on known padel-spec labels.
   ============================================================ */
(function () {
  var el = document.querySelector('[data-spec-mf]');
  if (!el) return;
  var rows = [];
  function pushPair(t) {
    t = (t || '').replace(/\s+/g, ' ').trim();
    if (!t) return;
    // Label separator: first ": " or a spaced dash " - " / " – " / " — "
    // (a bare hyphen inside a value like "360-375g" has no spaces, so it's ignored).
    var m = t.match(/:\s|\s[-–—]\s/);
    var idx, sep;
    if (m) { idx = m.index; sep = m[0].length; }
    else { idx = t.indexOf(':'); sep = 1; }   // fallback: bare colon
    if (idx < 1) return;
    var k = t.slice(0, idx).trim(), v = t.slice(idx + sep).trim();
    if (k && v && k.length <= 40) rows.push([k, v]);
  }
  // Preferred: one spec per line item (li / p) — robust for ANY label
  var items = el.querySelectorAll('li, p');
  if (items.length >= 2) {
    items.forEach(function (it) { pushPair(it.textContent); });
  }
  // Fallback: legacy single-paragraph run-on text — split on known spec labels
  if (rows.length < 2) {
    rows = [];
    var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!raw) return;
    // longest / multi-word keys first so they match before shorter ones
    var KEYS = [
      'Reference player', 'Frame material', 'Weight range', 'Sweet spot', 'Play level',
      'Shape', 'Core', 'Material', 'Technology', 'Technologies', 'Weight', 'Finish',
      'Level', 'Collection', 'Balance', 'Brand', 'Frame', 'Surface', 'Profile',
      'Format', 'Rubber', 'Grip', 'Player', 'Series', 'Thickness', 'Face', 'Length'
    ];
    var re = new RegExp('(?=(?:' + KEYS.join('|') + ')\\s*:)', 'g');
    raw.split(re).forEach(function (seg) { pushPair(seg); });
  }

  // Quick-spec cells below the buy button — fill Weight/Balance/Shape/Core from
  // the same parsed spec rows (dynamic, not hardcoded).
  (function () {
    var quick = document.querySelector('[data-pdp-specs]');
    if (!quick) return;
    var syn = {
      weight: ['weight', 'weight range', 'approximate weight'],
      balance: ['balance', 'balance type', 'balance point', 'blade balance'],
      shape: ['shape', 'head shape', 'blade shape'],
      core: ['core', 'core composition', 'core material', 'rubber', 'nucleus']
    };
    // "355 - 375 Grams" is how the metafield stores it; "355-375 g" is how a spec
    // panel should read. Cosmetic only — the source data is untouched.
    function tidy(v) {
      return String(v)
        .replace(/\s*[-\u2013]\s*/g, '\u2013')
        .replace(/\s*grams?\b/i, ' g')
        .replace(/\s+/g, ' ')
        .trim();
    }
    var filled = 0;
    quick.querySelectorAll('[data-spec-cell]').forEach(function (cell) {
      if (cell.hasAttribute('data-spec-locked')) { filled++; return; } // server value (e.g. Shape from metafield) — keep
      var key = (cell.getAttribute('data-spec-cell') || '').toLowerCase();
      var keys = syn[key] || [key];
      var hit = rows.find(function (r) { return keys.indexOf(r[0].toLowerCase()) !== -1; });
      if (hit) { cell.querySelector('[data-spec-val]').textContent = tidy(hit[1]); filled++; }
      // No value for this spec: drop the cell rather than leave a dangling "—".
      // Removed (not hidden) so :last-child still finds the real last cell for its border.
      else cell.remove();
    });
    if (filled) quick.hidden = false; else quick.remove();
  })();

  if (rows.length < 2) return; // couldn't parse — leave the original text as-is
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var brand = el.getAttribute('data-brand');
  if (brand && !rows.some(function (r) { return r[0].toLowerCase() === 'brand'; })) rows.unshift(['Brand', brand]);
  var html = '<table class="spec-table">';
  rows.forEach(function (r) { html += '<tr><td>' + esc(r[0]) + '</td><td>' + esc(r[1]) + '</td></tr>'; });
  html += '</table>';
  el.classList.remove('rte', 'spec-mf');
  el.innerHTML = html;
})();

/* Brand switcher — center the active brand pill in its scroll strip (no page scroll) */
(function () {
  var row = document.querySelector('.brand-switch__row');
  if (!row) return;
  var a = row.querySelector('.brand-switch__pill.is-active');
  if (!a) return;
  var ar = a.getBoundingClientRect(), rr = row.getBoundingClientRect();
  row.scrollLeft += (ar.left - rr.left) - (rr.width - ar.width) / 2;
})();

/* Hero image slider — arrows, dots, autoplay, swipe, keyboard.
   Progressive: markup renders fully without JS (first slide visible via CSS). */
(function () {
  document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
    var track = root.querySelector('[data-hero-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.hero__slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var i = 0, count = slides.length;

    function render() {
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      slides.forEach(function (s, idx) {
        if (idx === i) { s.setAttribute('data-hero-active', ''); }
        else { s.removeAttribute('data-hero-active'); }
      });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    function go(n) { i = (n + count) % count; render(); }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }

    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); reset(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); reset(); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); reset(); }); });

    // Keyboard when the slider has focus
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); reset(); }
      else if (e.key === 'ArrowRight') { next(); reset(); }
    });

    // Autoplay (pause on hover / focus / when tab hidden)
    var timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = (parseFloat(root.getAttribute('data-hero-autoplay')) || 0) * 1000;
    function play() { if (!interval || reduce) return; stop(); timer = setInterval(next, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function reset() { if (interval && !reduce) { stop(); play(); } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });

    // Swipe / drag
    var x0 = null, dx = 0, dragging = false;
    function down(x) { x0 = x; dx = 0; dragging = true; stop(); track.style.transition = 'none'; }
    function move(x) {
      if (!dragging || x0 === null) return;
      dx = x - x0;
      track.style.transform = 'translateX(calc(' + (-i * 100) + '% + ' + dx + 'px))';
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      var threshold = root.clientWidth * 0.15;
      if (dx <= -threshold) next();
      else if (dx >= threshold) prev();
      else render();
      x0 = null; dx = 0; play();
    }
    track.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchend', up);
    track.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', up);

    render();

    /* Hold autoplay until the page has finished loading. On a slow connection the
       5s timer was firing before first paint, so the hero advanced to slide 2 and
       the LCP element became a deferred slide image instead of the preloaded first
       slide -- pushing LCP from 11.8s to 13.3s. Starting on load keeps slide 1
       (eager + fetchpriority=high) as the LCP candidate, and by then the deferred
       slides have been hydrated. A 12s cap covers pages where `load` never settles. */
    if (document.readyState === 'complete') {
      play();
    } else {
      var started = false;
      var startOnce = function () { if (!started) { started = true; play(); } };
      window.addEventListener('load', startOnce, { once: true });
      setTimeout(startOnce, 12000);
    }
  });
})();

/* Reels coverflow (stack) carousel — center card large, neighbours scale/rotate
   back. Side-card click centers it; center card follows its link. Optional
   inline muted video on the active card. */
(function () {
  document.querySelectorAll('[data-reels]').forEach(function (root) {
    var stage = root.querySelector('[data-reels-stage]');
    if (!stage) return;
    var cards = Array.prototype.slice.call(stage.querySelectorAll('[data-reel-card]'));
    if (!cards.length) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-reels-dot]'));
    var N = cards.length;
    var active = 0;

    function layout() {
      var cw = cards[0].offsetWidth || 320;
      var half = N / 2;
      cards.forEach(function (card, i) {
        // shortest circular offset from the active card, in (-N/2, N/2]
        var o = ((i - active) % N + N) % N;
        if (o > half) o -= N;
        var ao = Math.abs(o), x, s, rot, op, z;
        if (o === 0) { x = 0; s = 1; rot = 0; op = 1; z = N + 1; }
        else {
          x = (o > 0 ? 1 : -1) * (cw * 0.6 + (ao - 1) * cw * 0.42);
          s = Math.max(0.55, 1 - ao * 0.14);
          rot = (o > 0 ? -1 : 1) * Math.min(22, 10 + ao * 4);
          op = ao >= 3 ? 0 : Math.max(0.3, 1 - ao * 0.28);
          z = N - ao;
        }
        var tf = 'translate(-50%,-50%) translateX(' + x + 'px) scale(' + s + ') rotateY(' + rot + 'deg)';
        // A card that jumps across the ring (leaving one edge, re-entering the
        // other) snaps into place without sliding — keeps the loop seamless.
        if (card._ro !== undefined && Math.abs(o - card._ro) > half) {
          card.style.transition = 'none';
          card.style.opacity = 0;
          card.style.transform = tf;
          void card.offsetWidth;               // force reflow
          card.style.transition = '';
        }
        card._ro = o;
        card.style.transform = tf;
        card.style.opacity = op;
        card.style.zIndex = z;
        card.style.pointerEvents = ao >= 3 ? 'none' : 'auto';
        card.classList.toggle('is-active', o === 0);
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
      syncVideos();
    }
    function go(n) { active = ((n % N) + N) % N; layout(); reset(); }   // wraps infinitely
    function next() { go(active + 1); }
    function prev() { go(active - 1); }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function (e) { if (i !== active) { e.preventDefault(); go(i); } });
    });
    var pb = root.querySelector('[data-reels-prev]'), nb = root.querySelector('[data-reels-next]');
    if (pb) pb.addEventListener('click', prev);
    if (nb) nb.addEventListener('click', next);
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') prev(); else if (e.key === 'ArrowRight') next(); });

    function syncVideos() {
      cards.forEach(function (card) {
        var vurl = card.getAttribute('data-reel-video');
        var vid = card.querySelector('video');
        if (card.classList.contains('is-active') && vurl) {
          if (!vid) {
            vid = document.createElement('video');
            vid.src = vurl; vid.muted = true; vid.loop = true; vid.autoplay = true;
            vid.setAttribute('playsinline', ''); vid.setAttribute('muted', '');
            card.querySelector('.reel-card__media').appendChild(vid);
          }
          vid.play().then(function () { card.classList.add('is-playing'); }).catch(function () {});
        } else if (vid) { vid.pause(); vid.remove(); card.classList.remove('is-playing'); }
      });
    }

    var interval = (parseFloat(root.getAttribute('data-reels-autoplay')) || 0) * 1000, timer = null;
    function play() { if (!interval) return; stop(); timer = setInterval(function () { active >= cards.length - 1 ? go(0) : next(); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function reset() { if (interval) { stop(); play(); } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);

    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (dx <= -40) next(); else if (dx >= 40) prev(); x0 = null; play(); });

    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(layout, 120); });
    layout();
    play();
  });
})();

/* Mobile nav accordion — smooth open/close by animating to the submenu's actual
   height (measured), then releasing to auto so nested content never clips. */
(function () {
  document.querySelectorAll('[data-mnav-toggle]').forEach(function (btn) {
    var item = btn.closest('[data-mnav-item]');
    var sub = item && item.querySelector('[data-mnav-sub]');
    if (!item || !sub) return;
    btn.addEventListener('click', function () {
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        sub.style.maxHeight = sub.scrollHeight + 'px';
        var done = function (e) {
          if (e.propertyName !== 'max-height') return;
          if (item.classList.contains('is-open')) sub.style.maxHeight = 'none';
          sub.removeEventListener('transitionend', done);
        };
        sub.addEventListener('transitionend', done);
      } else {
        sub.style.maxHeight = sub.scrollHeight + 'px';  // from 'none' → fixed px
        void sub.offsetHeight;                          // reflow so the next line animates
        sub.style.maxHeight = '0px';
      }
    });
  });
})();

/* Copy discount code to clipboard (footer WELCOME06 badge) */
(function () {
  document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-copy-code') || '';
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
      } else {
        var t = document.createElement('textarea');
        t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(t);
      }
    });
  });
})();

/* Newsletter — AJAX subscribe with button loader, success message + themed confetti */
(function () {
  function confetti() {
    var colors = ['#D7FF3C', '#B8E000', '#0B1220', '#F4F1EA', '#E0533D'];
    var cv = document.createElement('canvas');
    cv.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:99999';
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d');
    cv.width = window.innerWidth; cv.height = window.innerHeight;
    var P = [], N = 170;
    for (var i = 0; i < N; i++) {
      P.push({ x: cv.width * (0.28 + Math.random() * 0.44), y: cv.height * 0.42,
        vx: (Math.random() - 0.5) * 17, vy: (Math.random() * -17) - 4,
        s: 5 + Math.random() * 7, c: colors[i % colors.length],
        rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.5, life: 1 });
    }
    function frame() {
      ctx.clearRect(0, 0, cv.width, cv.height);
      var alive = false;
      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        p.vy += 0.4; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life -= 0.009;
        if (p.life > 0 && p.y < cv.height + 30) {
          alive = true;
          ctx.save(); ctx.globalAlpha = Math.max(0, p.life);
          ctx.translate(p.x, p.y); ctx.rotate(p.rot);
          ctx.fillStyle = p.c; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.62);
          ctx.restore();
        }
      }
      if (alive) requestAnimationFrame(frame); else cv.remove();
    }
    requestAnimationFrame(frame);
  }

  // The newsletter forms post natively — see padelit-newsletter.liquid. Submitting
  // them with fetch tripped Shopify's bot checkpoint (403 "Verifying your
  // connection"), so signups silently failed. Liquid renders the result now; all
  // that's left here is the confetti, fired when the server returns the success
  // state after the redirect.
  /* ---------- Welcome popup ----------
     Shown once per visitor, tracked in localStorage. Storage can throw in private
     windows or when cookies are blocked, so every access is guarded — a failure
     there must not stop the popup working, it just means it may show again. */
  (function () {
    var pop = document.querySelector('[data-welcome-popup]');
    if (!pop) return;
    var KEY = pop.getAttribute('data-key') || 'padelit_welcome_v1';
    var seen = function () { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
    var markSeen = function () { try { localStorage.setItem(KEY, '1'); } catch (e) {} };

    function open() {
      if (typeof hideTab === 'function') hideTab();
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      markSeen();
      var input = pop.querySelector('.wpop__input');
      if (input) setTimeout(function () { input.focus(); }, 320);
    }
    function close() {
      pop.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { pop.hidden = true; }, 280);
      showTab();
    }
    var tab = document.querySelector('[data-wpop-open]');
    function showTab() { if (tab) tab.hidden = false; }
    function hideTab() { if (tab) tab.hidden = true; }
    if (tab) tab.addEventListener('click', function () { hideTab(); open(); });

    pop.querySelectorAll('[data-wpop-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });

    // After a successful signup the page has reloaded with the code rendered —
    // always show that, even to a visitor who has already seen the popup.
    if (pop.hasAttribute('data-force-open')) { open(); return; }
    // Already seen it: no auto-open, just offer the tab as the way back in.
    if (seen()) { showTab(); return; }
    var delay = parseFloat(pop.getAttribute('data-delay') || '6') * 1000;
    setTimeout(open, isNaN(delay) ? 6000 : delay);
  })();

  // Copy-to-clipboard for the popup code (mirrors the footer badge behaviour)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.wpop__copy');
    if (!btn) return;
    var code = btn.getAttribute('data-copy-code') || '';
    if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
    btn.classList.add('is-copied');
    setTimeout(function () { btn.classList.remove('is-copied'); }, 1400);
  });

  var successBox = document.querySelector('[data-newsletter-success]');
  if (successBox) {
    confetti();
    successBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
})();
